import React from 'react';
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import {withStyles} from "@material-ui/styles";
import MuiTable from "../common/MuiTable";
import {
    approvedSupplierList, deleteApprovedSupplierList,
    saveOrUpdateApprovedSupplierList, exportReport, approvedSupplierListRevision,
} from "../../util/ApiUtils";
import {NotificationManager, NotificationContainer} from "react-notifications";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import {Spinner} from "../common/Spinner";
import DocumentControlHeader from "./ApprovedSupplierListDocumentControlHeader";
import * as CommonUtils from "../../util/CommonUtils";

const classes = ((theme) => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

const columns = [
    {
        title: 'id',
        field: 'id',
        type: "numeric",
        hidden: true,
    },
    {
        title: 'Supplier Name',
        field: 'name',
        type: "string",
        cellStyle: {
            width: '12%'
        }
    },
    {
        title: 'Supplier Contact Name',
        field: 'contactName',
        type: "string",
        cellStyle: {
            width: '12%'
        }
    },
    {
        title: 'Supplier Contact Landline or Mobile Number',
        field: 'contactPhoneNumber',
        type: "string",
        cellStyle: {
            width: '12%'
        }
    },
    {
        title: 'Supplier Address',
        field: 'address',
        type: "string",
        cellStyle: {
            width: '12%'
        }
    },
    {
        title: 'Product / Service Provided',
        field: 'productService',
        type: "string",
        cellStyle: {
            width: '15%'
        }
    },
    {
        title: 'Any Customer Complaints Relating to the Supplier',
        field: 'complaints',
        type: "string",
        cellStyle: {
            width: '12%'
        }
    },
    {
        title: 'Work Completed On Time and On Budget?',
        field: 'onTimeOnBudget',
        type: "string",
        cellStyle: {
            width: '12%'
        }
    },
    {
        title: 'Any Rework Required?',
        field: 'reworkRequired',
        type: "string",
        cellStyle: {
            width: '12%'
        }
    },
    {
        title: 'Approved Supplier',
        field: 'isApproved',
        lookup: { yes : 'Yes' , no : 'No' },
    },
];

class ApprovedSupplierList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            approvedSupplierList: [],
            isLoading: true,
        };
        this.loadApprovedSupplierList = this.loadApprovedSupplierList.bind(this);
        this.handleSaveOrUpdate = this.handleSaveOrUpdate.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.isValid = this.isValid.bind(this);
        this.onYearSelected = this.onYearSelected.bind(this);
    }

    componentDidMount() {
        const selectedYear = moment(new Date()).format('YYYY');
        this.setState({
            selectedYear: selectedYear,
        });
        this.loadApprovedSupplierList(selectedYear);
    }

    onYearSelected(event, selectedYear) {
        this.setState({
            selectedYear: selectedYear,
        });
        this.loadApprovedSupplierList(selectedYear);
    }

    loadApprovedSupplierList(selectedYear) {
        console.log('with selected year ' + selectedYear);
        approvedSupplierList()
            .then(response => {
                console.log(response);
                let suppliersThisYear = response.filter(function(approvedSupplier) {
                    console.log('approvedSupplier.approvedYear === selectedYear ' + (approvedSupplier.approvedYear === parseInt(selectedYear)));
                    return approvedSupplier.approvedYear === parseInt(selectedYear);
                });
                this.setState({
                    approvedSupplierList: suppliersThisYear,
                });
                approvedSupplierListRevision()
                    .then(response => {
                        console.log('Revision');
                        console.log(response);
                        this.setState({
                            latestRevision: response,
                            isLoading: false,
                        });
                    })
                    .catch(error => {
                        console.log(error);
                    });
            })
            .catch(error => {
                console.log(error);
            });
    }

    handleSaveOrUpdate(approvedSupplierListRequest) {
        console.log(approvedSupplierListRequest);
        approvedSupplierListRequest.approvedYear = this.state.selectedYear;
        console.log(approvedSupplierListRequest);
        saveOrUpdateApprovedSupplierList(approvedSupplierListRequest)
            .then(() => {
                this.loadApprovedSupplierList(this.state.selectedYear);
                NotificationManager.success('Success', 'The Approved Supplier List has been updated.', 5000);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    handleDelete(approvedSupplierListRequest) {
        console.log(approvedSupplierListRequest);
        deleteApprovedSupplierList(approvedSupplierListRequest)
            .then(() => {
                this.loadApprovedSupplierList(this.state.selectedYear);
                NotificationManager.success('Success', 'The Approved Supplier List has been updated.', 5000);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    isValid(newData) {
        let isValid = newData.name && newData.name !== '';
        if (!isValid) {
            NotificationManager.error('Error', 'Validation Error. Supplier Name is required', 5000);
        }
        return isValid;
    }

    render() {
        let { state } = this;
        let { classes } = this.props;
        if (state.isLoading) {
            return <Spinner/>;
        }
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        return <div>
            <Typography component="h2" variant="h5">
                <div style={{float: 'left'}}>APPROVED SUPPLIER LIST</div>
            </Typography>
            <DocumentControlHeader revision={state.latestRevision} isAuditor={isAuditor}>
                <Paper className={classes.root} style={{ marginTop: '30px' }}>
                    <MuiTable
                        title={
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <KeyboardDatePicker
                                    style={{float: 'right'}}
                                    disableToolbar
                                    autoOk
                                    variant="inline"
                                    format="YYYY"
                                    margin="normal"
                                    id="selectedYear"
                                    label="Filter by Year"
                                    name="selectedYear"
                                    value={state.selectedYear}
                                    views={['year']}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    onChange={ this.onYearSelected}
                                />
                            </MuiPickersUtilsProvider>
                        }
                        columns={columns}
                        data={state.approvedSupplierList}
                        onAdd={this.handleSaveOrUpdate}
                        onUpdate={this.handleSaveOrUpdate}
                        onDelete={this.handleDelete}
                        exportButton={!isDemo}
                        onExport={() => exportReport('/approved-supplier-list/export')}
                        isValid={this.isValid}
                        allowUpdateDelete={isAuditor ? 'no' : 'yes'}
                    />
                </Paper>
            </DocumentControlHeader>
            <NotificationContainer/>
        </div>;
    }
}

export default withStyles(classes)(ApprovedSupplierList);